
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 171.333 171\" id=\"icon-external\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M147,100.5h24v39.17c0,17.28-14.05,31.33-31.33,31.33H31.33C14.05,171,0,156.95,0,139.67V31.33C0,14.05,14.05,0,31.33,0\r\n\tH70.5v24H31.33C27.29,24,24,27.29,24,31.33v108.34c0,4.04,3.29,7.33,7.33,7.33h108.34c4.04,0,7.33-3.29,7.33-7.33V100.5z M96,0v24\r\n\th34.02l-81.51,81.51l16.98,16.98l81.84-81.84V75.5h24V0H96z\"/> </symbol>";
module.exports = sprite.add(image, "icon-external");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/external.svg
 ** module id = 174
 ** module chunks = 24
 **/